import { mount } from 'svelte'
import App from './App.svelte'
import './app.css'

const target = document.getElementById('app')
if (!target) throw new Error('app mount target is missing')
const app = mount(App, { target })

export default app
